import { App } from "antd";
import lodash from "lodash";
import moment from "moment";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  setBailiffDialogKick,
  setBailiffDialogPlay,
} from "store/bailiff/bailiff/dialog/bailiff_dialog.action";
import {
  bailiffDialogAllSelector,
  bailiffDialogPlaySelector,
  bailiffDialogSecondSelector,
} from "store/bailiff/bailiff/dialog/bailiff_dialog.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const useActionDialogRefine = () => {
  // -------------------------- VAR -----------------------------
  const { message } = App?.useApp();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const play = useSelector(bailiffDialogPlaySelector);
  const dialogs = useSelector(bailiffDialogAllSelector);
  const second = useSelector(bailiffDialogSecondSelector);
  const sorted = lodash.orderBy(dialogs, "slot", "asc");
  const mapped = sorted?.map((s) => s?.sentences) || [];
  const flatten = lodash.flatten(mapped) || [];
  const duration = flatten?.[flatten?.length - 1]?.to;
  const start = flatten?.[0]?.from || 0;
  const index =
    flatten?.findIndex((f) => second >= f?.from && second <= f?.to) || 0;
  const total = flatten?.length || 0;
  // -------------------------- FUNCTION ------------------------
  const handlePrevDialog = useCallback(() => {
    if (total === 1) return message.warning("Chỉ có một đoạn văn");
    if (index === 0) return message.warning("Đã đến giới hạn cuối");

    const prev = index - 1;
    const prevSelected = flatten?.[prev] || null;
    const prevSecond = prevSelected?.from || 0;
    const frozen = `change-${moment()?.valueOf()}-${prevSecond}`;
    dispatch(setBailiffDialogKick(frozen));
    dispatch(setBailiffDialogPlay(!play));
  }, [dispatch, index, play, total]);

  // next
  const handleNextDialog = useCallback(() => {
    if (total === 1) return message.warning("Chỉ có một đoạn văn");
    if (index === total - 1) return message.warning("Đã đến giới hạn cuối");

    const next = index + 1;
    const nextSelected = flatten?.[next] || null;
    const nextSecond = nextSelected?.from || 0;
    const frozen = `change-${moment()?.valueOf()}-${nextSecond}`;
    dispatch(setBailiffDialogKick(frozen));
    dispatch(setBailiffDialogPlay(!play));
  }, [dispatch, index, play, total]);

  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { second, start, duration, handlePrevDialog, handleNextDialog };
};
export default useActionDialogRefine;
